export default "__VITE_ASSET__pGX0qIJr__"